import { render, staticRenderFns } from "./UnrelatedFields.vue?vue&type=template&id=2ea22ebc&scoped=true"
import script from "./UnrelatedFields.vue?vue&type=script&lang=js"
export * from "./UnrelatedFields.vue?vue&type=script&lang=js"
import style0 from "./UnrelatedFields.vue?vue&type=style&index=0&id=2ea22ebc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ea22ebc",
  null
  
)

export default component.exports